export default __webpack_public_path__ + "static/media/background.c8392bfc.webp";